<script lang="ts">
    import Select from "../../../leafElement/Select.svelte";
    import Input from "../../../leafElement/Input.svelte";
    import { getUid } from "../../../script/common";
    import {
        MES_KEY_STAGE,
        MES_STAGE_MAP,
        MES_STAGE_MAP_KEYS,
    } from "../../../script/enum";
    import Switch from "../../../leafElement/Switch.svelte";
    import InputSelect from "../../../leafElement/InputSelect.svelte";

    export let ruleList;
    $: if (ruleList && ruleList._uid === undefined) {
        ruleList._uid = getUid();
    }
    export let headerList: {
        select: {
            name: string;
            value: {
                index: number;
                avalibleVal: any[];
                type: string;
            };
        }[];
    } = { select: [] };
    export let reloadData;
    export let parentDestructor = null;
    const fullOpList = [
        {
            name: "neprázdný",
            value: "notisEmpty",
        },
        {
            name: "prázdný",
            value: "isEmpty",
        },
        {
            name: "=",
            value: "eq",
        },
        {
            name: "≠",
            // name: "jiné než",
            value: "noteq",
        },
        {
            name: ">",
            value: "more",
        },
        {
            name: "<",
            value: "less",
        },
        {
            name: "má",
            value: "length",
        },
    ];
    const fullOpList_sort = [
        {
            name: "sestupně",
            value: "max",
        },
        {
            name: "vzestupně",
            value: "min",
        },
    ];
    const avalibleFilterOperation = {
        title: getAvalibleOperationRec(fullOpList.slice(0, 4)),
        string: getAvalibleOperationRec(fullOpList.slice(0, 4)),
        number: getAvalibleOperationRec(fullOpList.slice(0, 6)),
        time: getAvalibleOperationRec(fullOpList.slice(0, 2)),
        tripleCounter: getAvalibleOperationRec(fullOpList.slice(6, 7)),
        boolean: getAvalibleOperationRec(fullOpList.slice(0, 2)),
        mesState: getAvalibleOperationRec(fullOpList.slice(2, 6)),
    };
    function getAvalibleOperationRec(
        data: {
            name: string;
            value: string;
        }[]
    ) {
        return {
            list: data,
            map: data.reduce((acc, val) => {
                acc[val.value] = true;
                return acc;
            }, {}),
        };
    }

    let _valueTypeId = 2; // TODO
    const avalibleValueType = {
        none: _valueTypeId++,
        str: _valueTypeId++,
        num: _valueTypeId++,
        mesState: _valueTypeId++,
        dtStateLen: _valueTypeId++,
    };
    const mesStageList = MES_STAGE_MAP_KEYS.map((key) => ({
        name: MES_STAGE_MAP[key].text,
        value: key,
    }));
    const dtLenList = [
        { name: "3 bodů", value: 3 },
        { name: "6 bodů", value: 6 },
    ];

    function deleteFun(id) {
        let arrPos = -1;
        for (let i = 0; i < ruleList.sub.length; i++) {
            if (ruleList.sub[i]._uid == id) {
                arrPos = i;
                break;
            }
        }
        if (arrPos == -1) {
            console.warn("uid mismatch!");
            return;
        }
        ruleList.sub.splice(arrPos, 1);
        ruleList = ruleList;
        // check if is root
        if (ruleList.sub.length == 0 && parentDestructor) {
            destroySelf();
        }
    }
    function destroySelf() {
        parentDestructor(ruleList._uid);
    }
    function addAnd() {
        if (ruleList.type == "filter_and") {
            addVal();
        } else {
            ruleList.sub.push({
                type: "filter_and",
                _uid: getUid(),
                sub: [getNewValFilter()],
            });
            ruleList = ruleList;
        }
    }
    function addOr() {
        if (ruleList.type == "filter_or") {
            addVal();
        } else {
            ruleList.sub.push({
                type: "filter_or",
                _uid: getUid(),
                sub: [getNewValFilter()],
            });
            ruleList = ruleList;
        }
    }
    function addVal() {
        ruleList.sub.push(getNewValFilter());
        ruleList = ruleList;
    }
    function getNewValFilter() {
        return {
            type: "filter_val",
            trg: {
                atr: 0,
                operaion: "notisEmpty",
                val: "",
            },
            _uid: getUid(),
        };
    }
    function addValSort() {
        ruleList.sub.push({
            type: "sort_val",
            trg: {
                atr: 0,
                operaion: "max",
                val: "",
            },
            _uid: getUid(),
        });
        ruleList = ruleList;
    }

    let atrSelected;
    let atrSelected_sort;
    let reverseSort = 0;

    let artAvalible = [];
    $: getArtList(headerList);
    function getArtList(headerData) {
        if (!headerData || !headerData.select) {
            artAvalible = [];
            return;
        }
        artAvalible = headerData.select;
        const newId =
            ruleList.trg && ruleList.trg.atr
                ? ruleList.trg.atr
                : headerData.select.length !== 0
                ? headerData.select[0].value
                : null;
        atrSelected = newId;
        atrSelected_sort = newId;
    }

    let operSelected;
    let operAvalible = [];
    // $: atrSelected ? setOperlist(atrSelected.type) : [];
    function setOperlist(type: string) {
        let list = avalibleFilterOperation;
        /* if (ruleList.type == "filter_val") {
            list = avalibleFilterOperation;
        } else {
            list = avalibleFilterOperation_sort;
        } */
        if (!(type in list)) return [];
        operAvalible = list[type].list;
        operSelected =
            ruleList.trg && ruleList.trg.operaion in list[type].map
                ? ruleList.trg.operaion
                : list[type].list.length !== 0
                ? list[type].list[0].value
                : null;
    }

    let valueSelected;
    let valueType;
    let valAValible = [];
    /* $: valueType =
        atrSelected && operSelected
            ? genValType(atrSelected.type, operSelected)
            : avalibleValueType.none; */
    function genValType(
        atrType: string,
        operation: string,
        avalibleValList: any[]
    ) {
        if (!atrType || !operation) return avalibleValueType.none; // no need
        if (ruleList.type == "filter_val") {
            valAValible = [];
            if (operation == "isEmpty" || operation == "notisEmpty")
                return avalibleValueType.none;
            else if (atrType === "mesState") {
                valueSelected = MES_STAGE_MAP[MES_KEY_STAGE.default];
                return avalibleValueType.mesState;
            } else if (atrType === "number") return avalibleValueType.num;
            else if (atrType === "tripleCounter" && operation == "length") {
                valueSelected = dtLenList[0].value;
                return avalibleValueType.dtStateLen;
            }
            valAValible = avalibleValList.map((val) => ({
                name: val,
                value: val,
            }));
            return avalibleValueType.str;
        } else {
            // sort
            return avalibleValueType.none;
        }
    }

    $: if (
        ruleList.type == "filter_val" &&
        ruleList &&
        ruleList.trg &&
        changeEnable
    )
        ruleList.trg.atr = atrSelected ? atrSelected.index : null;
    $: if (
        ruleList.type == "sort_val" &&
        ruleList &&
        ruleList.trg &&
        changeEnable
    )
        ruleList.trg.atr = atrSelected_sort ? atrSelected_sort.index : null;

    $: if (
        ruleList.type == "filter_val" &&
        ruleList &&
        ruleList.trg &&
        changeEnable
    )
        ruleList.trg.operaion = operSelected ? operSelected : null;
    $: if (
        ruleList.type == "sort_val" &&
        ruleList &&
        ruleList.trg &&
        changeEnable
    )
        ruleList.trg.operaion = reverseSort ? "min" : "max";
    $: console.log("sVal", valueSelected);
    $: if (
        ruleList.type == "filter_val" &&
        ruleList &&
        ruleList.trg &&
        changeEnable
    )
        ruleList.trg.val = valueSelected ? valueSelected : null;
    $: if (
        ruleList.trg &&
        (ruleList.trg.atr || ruleList.trg.operaion || ruleList.trg.val)
    ) {
        console.log("REALODING FILTER");
        reloadData();
    }

    // EXTREAMLY BAD IDEA - START
    let changeEnable = false;
    setTimeout(() => {
        changeEnable = true;
    }, 100);
    // EXTREAMLY BAD IDEA - END

    function onAtrSet() {
        if (changeEnable) {
            valueSelected = null;
            operSelected = null;
        }
        setOperlist(atrSelected.type);
        onOperationSet(); // TODO
    }
    function onOperationSet() {
        if (changeEnable) {
            valueSelected = null;
        }
        valueType =
            atrSelected && operSelected
                ? genValType(
                      atrSelected.type,
                      operSelected,
                      atrSelected.avalibleVal || [] /* NOT neaded */
                  )
                : avalibleValueType.none;
    }
</script>

<div class="root">
    <!-- <div class="content"> -->
    {#if !ruleList}
        <div class="rule">
            <span>ERR</span>
        </div>
    {:else if ruleList.type == "filter_and" || ruleList.type == "filter_or" || ruleList.type == "sort_list"}
        <div
            style={ruleList.isRoot && ruleList.sub.length == 0
                ? "--lineCollor: none;"
                : "--lineCenter: calc(1.5rem - 1px);"}
            class={ruleList.isRoot ? "listInRoot" : "list"}
        >
            <div class="lineHorizontal" />
            <div class="lineVertical" />
            <div class="content" style="--lineCenter: 2rem;">
                <!-- {#if ruleList.sub.length == 0}
                    <button class="sgButton" on:click={addAnd}>
                        <span class="material-icons"> add </span>
                        <span>Zároveň</span>
                    </button>
                    <button class="sgButton" on:click={addOr}>
                        <span class="material-icons"> add </span>
                        <span>Nebo</span>
                    </button>
                {/if} -->
                {#each ruleList.sub as rule, i}
                    <div class="lineHorizontal" />
                    <div class="nextContent">
                        <svelte:self
                            bind:ruleList={rule}
                            bind:headerList
                            {reloadData}
                            parentDestructor={deleteFun}
                        />
                        {#if i != ruleList.sub.length - 1 && (ruleList.type == "filter_and" || ruleList.type == "filter_or")}
                            {#if ruleList.type == "filter_and"}
                                <span class="linkText">zároveň</span>
                            {:else if ruleList.type == "filter_or"}
                                <span class="linkText">nebo</span>
                            {/if}
                        {/if}
                    </div>
                {/each}
                <div class="nextContent">
                    <div
                        class="filterEndWrap"
                        style="flex-direction: {ruleList.type == 'filter_and'
                            ? 'row'
                            : 'row-reverse'}"
                    >
                        {#if (ruleList.type == "filter_and" || ruleList.type == "filter_or") && ruleList.isRoot && ruleList.sub.length == 0}
                            <button class="sgButton" on:click={addVal}>
                                <span class="material-icons"> add </span>
                                <span>Přidat</span>
                            </button>
                        {:else if ruleList.type == "sort_list"}
                            <button class="sgButton" on:click={addValSort}>
                                <span class="material-icons"> add </span>
                                <span>Přidat</span>
                            </button>
                        {:else}
                            <button class="sgButton" on:click={addAnd}>
                                <span class="material-icons"> add </span>
                                <span>Zároveň</span>
                            </button>
                            <button class="sgButton" on:click={addOr}>
                                <span class="material-icons"> add </span>
                                <span>Nebo</span>
                            </button>
                        {/if}
                    </div>
                </div>

                <!---->
            </div>
        </div>
    {:else if ruleList.type == "filter_val"}
        <div class="rule">
            <div class="ruleContent">
                <div>
                    <Select
                        name={"atr"}
                        bind:userSelected={atrSelected}
                        on:change={onAtrSet}
                        optionsList={artAvalible}
                    />
                </div>
                {#if operAvalible.length != 0}
                    <div>
                        <Select
                            name={"op"}
                            bind:userSelected={operSelected}
                            on:change={onOperationSet}
                            optionsList={operAvalible}
                        />
                    </div>
                {/if}
                <div>
                    {#if valueType === avalibleValueType.str}
                        <!-- <Input name={"hodnota"} bind:val={valueSelected} /> -->
                        <InputSelect
                            name={"hodnota"}
                            bind:inputValue={valueSelected}
                            optionsList={valAValible}
                        />
                    {:else if valueType === avalibleValueType.num}
                        <Input
                            inputType={"number"}
                            name={"hodnota"}
                            bind:val={valueSelected}
                        />
                    {:else if valueType === avalibleValueType.mesState}
                        <Select
                            name={"hodnote"}
                            bind:userSelected={valueSelected}
                            optionsList={mesStageList}
                        />
                    {:else if valueType === avalibleValueType.dtStateLen}
                        <Select
                            name={"hodnote"}
                            bind:userSelected={valueSelected}
                            optionsList={dtLenList}
                        />
                    {/if}
                </div>
            </div>
            <div class="actionList">
                <div
                    class="activeIcon inactiveIcon customIcon"
                    on:click={destroySelf}
                >
                    <span class="material-icons"> delete </span>
                </div>
            </div>
        </div>
    {:else if ruleList.type == "sort_val"}
        <div class="rule">
            <div class="ruleContent">
                <div>
                    <Select
                        name={"atr"}
                        bind:userSelected={atrSelected_sort}
                        optionsList={artAvalible}
                    />
                </div>
                <!-- {#if operAvalible.length != 0}
                    <div>
                        <Select
                            name={"op"}
                            bind:userSelected={operSelected}
                            optionsList={operAvalible}
                        />
                    </div>
                {/if} -->
                <div style="margin-left: 1rem;">
                    <Switch
                        iconA={"arrow_upward"}
                        iconB={"arrow_downward"}
                        bind:val={reverseSort}
                    />
                </div>
            </div>
            <div class="actionList">
                <div
                    class="activeIcon inactiveIcon customIcon"
                    on:click={destroySelf}
                >
                    <span class="material-icons"> delete </span>
                </div>
            </div>
        </div>{/if}
    <!-- </div> -->
</div>

<style>
    .root {
        --lineWidth: 4px;
        --layerWidth: 10px;
        --lineCollor: var(--prim_L2);
        /* --lineCollor: rgb(247, 250, 252); */
        --lineCenter: 2rem;
        --lineEnd: 1rem;
    }
    .list {
        display: grid;
        grid-template-columns: var(--lineWidth) auto 1fr;
        grid-template-columns: auto auto 1fr;
        margin: 0.5rem;
        margin-left: 0;
        border: solid var(--back_D15) 1px;
    }
    .listInRoot {
        display: grid;
        grid-template-columns: 0 auto 1fr;
        /* margin: 0.5rem;
        margin-left: 0; */
    }
    .listInRoot > .lineHorizontal {
        border-radius: 50%;
        position: relative;
        top: calc(-3 * var(--lineWidth) - 2px);
        right: calc(1 * var(--lineWidth) + 2px);
        width: calc(3 * var(--lineWidth));
        height: calc(3 * var(--lineWidth));
        background: none;
        border: solid 2px var(--lineCollor);
    }
    .content {
        display: grid;
        grid-template-columns: auto 1fr;
    }
    .lineVertical {
        background: var(--lineCollor);
        height: calc(
            100% - var(--lineCenter) - var(--lineEnd) + var(--lineWidth)
        );
        width: var(--lineWidth);
        margin-top: var(--lineCenter);
    }
    .lineHorizontal {
        background: var(--lineCollor);
        height: var(--lineWidth);
        width: var(--layerWidth);
        margin-top: var(--lineCenter);
        /* position: relative;
        padding: 0 2px;
        right: 1px; */
    }
    .nextContent {
        grid-column: 2;
    }
    .rule {
        margin: 0.5rem;
        margin-left: 3px;
        border: solid var(--back_D12) 1px;
        padding: 1rem;
        /* min-width: 100%; */
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .ruleContent {
        display: flex;
        flex-wrap: wrap;
    }
    .ruleContent > * {
        margin: 0 10px;
    }
    .ruleAtrName::after {
        content: "=";
        margin: 0 10px;
    }
    .filterEndWrap {
        display: flex;
        align-items: center;
        width: fit-content;
    }
    .linkText {
        color: var(--back_D18);
        margin: 8px 1.8rem;
    }
    .actionList {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }
    .customIcon {
        margin: 3px;
    }
    .customIcon > .material-icons {
        font-size: 1.5rem;
        color: var(--back_D15);
    }
    .customIcon:hover > .material-icons {
        color: var(--back_D2);
    }
    .customIcon > p {
        font-size: 1.2rem;
        color: var(--back_D15);
    }
    .customIcon:hover > p {
        color: var(--back_D2);
    }
</style>
